var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":'电池健康测评度',"isWidth700":true}}),_c('Chart',{attrs:{"cdata":_vm.cdata,"height":_vm.style.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }